import axios from "../instance";

export default {
  getAll: () => {
    return axios.api.get("/aaaaaa").then((response) => response.data);
  },
  
};
